module.exports = __webpack_public_path__ + "img/note.fab1ffd5.png";